import script from "./HelpView.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpView.vue?vue&type=script&setup=true&lang=js"

import "./HelpView.vue?vue&type=style&index=0&id=0fc44bec&lang=scss"

const __exports__ = script;

export default __exports__